<template>
  <b-modal
    v-model="show"
    :style="{ zIndex: 9000 }"
    modal-class="resignin-modal"
    body-class="resignin-modal-body"
    no-close-on-backdrop
    static
    centered
    hide-footer
  >
    <template #modal-header>
      <ModalHeader :onCloseButton="cancelReLogin" />
    </template>

    <SignInSignUpContent>
      <SignInForm ReSignin />
    </SignInSignUpContent>
  </b-modal>
</template>

<script>
import SignInForm from '@components/sign-up/SignInForm.vue'
import ModalHeader from '@components/modals/ModalHeader.vue'
import SignInSignUpContent from '@components/sign-up/SignInSignUpContent.vue'

export default {
  name: 'ReSignIn',
  components: { SignInSignUpContent, ModalHeader, SignInForm },
  data () {
    return {
      show: true
    }
  },
  methods: {
    cancelReLogin () {
      this.$router.push(this.ROUTES.SIGN_IN.name)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .resignin-modal.modal {
  .modal-dialog {
    max-width: $sign-in-form-width + 100px;
  }

  .resignin-modal-body {
    padding-bottom: 50px;
  }
}
</style>
